<template>
    <div
        class="card text-center shadow-sm"
        :class="{ presentation_card__active: isActive }"
    >
        <div class="card-body">
            <h5 class="card-title">{{ presentation.name }}</h5>
            <div class="card-text">
                <b-list-group></b-list-group>
                <b-list-group-item
                    v-for="service in getServices"
                    :key="service"
                >
                    {{ service }}
                </b-list-group-item>
            </div>
        </div>
        <div class="card-footer">
            <p>
                <span class="presentation__price">
                    {{
                        presentation.price_per_year > 0
                            ? presentation.price_per_year + ' Kč/rok'
                            : '&nbsp;'
                    }}
<!--                    {{-->
<!--                        getCenaBezDphPlacenyZapis > 0-->
<!--                            ? getCenaBezDphPlacenyZapis + ' Kč/rok'-->
<!--                            : '&nbsp;'-->
<!--                    }}-->
                </span>
            </p>
            <div class="pb-3">
                <button
                    :class="{
                        'button-02': isActive,
                        'button-01': !isActive,
                    }"
                    @click="$emit('pick-presentation', presentation)"
                >
                    {{ presentation.button_value }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PresentationCard',
    props: {
        presentation: {
            type: Object,
            required: true,
            validator() {
                return []
            },
        },
    },
    computed: {
        isActive() {
            if (this.isPicked()) {
                if (
                    this.$store.state.firm.presentation.id ==
                    this.presentation.id
                ) {
                    return true
                }
                return false
            }

            if (this.presentation.active == '1') {
                return true
            } else {
                return false
            }
        },
        // getCenaBezDphPlacenyZapis() {
        //   return this.$store.getters['presentations/cenaBezDphPlacenyZapis']
        // },
        getServices() {
            let services_string_semicolon_delimited = this.presentation.services
            if (services_string_semicolon_delimited != '') {
                return services_string_semicolon_delimited.split(/[;]+/)
            }
            return ''
        },
    },
    methods: {
        isPicked() {
            if (this.$store.state.firm.presentation.id > 0) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style scoped>
.list-group-item {
    background-color: transparent;
    border: none;
}
</style>
